import React, { useState, useEffect } from "react";
import Collapse from "@mui/material/Collapse";
import { useRouter } from "next/router";
import Link from "next/link";
import { useMediaQuery } from "react-responsive";
import { ReactSVG } from "react-svg";
import { getAssets } from "@unisearch/helpers";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { IconButton } from "@mui/material";
import { FaHashtag } from "react-icons/fa";
import styles from "./other_topic.module.scss";

const list = [
  {
    name: "Scholarship",
    member: 700,
    image: "./assets/images/review-person5.jpg",
    slug: "scholarship",
    groupSlug: "study-in-australia",
  },
  {
    name: "Classroom",
    member: 700,
    image: "./assets/images/review-person5.jpg",
    slug: "classroom",
    groupSlug: "study-in-australia",
  },
  {
    name: "Accomodation",
    member: 700,
    image: "./assets/images/review-person5.jpg",
    slug: "accomodation",
    groupSlug: "study-in-australia",
  },
  {
    name: "Job",
    member: 700,
    image: "./assets/images/review-person5.jpg",
    slug: "job",
    groupSlug: "study-in-australia",
  },
  {
    name: "Visa",
    member: 700,
    image: "./assets/images/review-person5.jpg",
    slug: "visa",
    groupSlug: "study-in-australia",
  },
  {
    name: "University",
    member: 700,
    image: "./assets/images/review-person5.jpg",
    slug: "university",
    groupSlug: "study-in-australia",
  },
];

const OtherTopic = ({ groupTopic }) => {
  const { asPath, query } = useRouter();
  const isMobile = useMediaQuery({
    query: "(max-width: 991px)",
  });
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (isMobile) {
      setOpen(false);
    }
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.heading}>
        <span>Group Topics</span>
        {isMobile && (
          <IconButton disableRipple>
            {open ? (
              <FiChevronUp onClick={handleClick} />
            ) : (
              <FiChevronDown onClick={handleClick} />
            )}
          </IconButton>
        )}
      </div>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <ul className={styles.item_group_wrapper}>
          {groupTopic &&
            groupTopic?.length > 0 &&
            groupTopic?.map((item, i) => (
              <li key={i}>
                <div className={styles.img_wrapper}>
                  <FaHashtag />
                </div>
                <div>
                  <h2 className={styles.title}>
                    <Link
                      legacyBehavior
                      href={`/forum/group/${item?.group.slug}/topics/${item.topicSlug}`}
                    >
                      <a>{item.topicTitle}</a>
                    </Link>
                  </h2>
                  {/*<p className={styles.text}>{item.member} members</p>*/}
                </div>
              </li>
            ))}
        </ul>
      </Collapse>
    </div>
  );
};

export default OtherTopic;
